import $ from "cash-dom";

export default (function () {
    $(window).on("load", function () {
        // Initial run
        processIframes($(".root-data-givewp-embed > iframe"));

        // Watch for new iframes
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeName === "IFRAME" && $(node).closest(".root-data-givewp-embed").length) {
                        processIframes($(node));
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        function processIframes($iframes) {
            $iframes.each(function () {
                const iframe = this;

                // Always attach a load listener (covers reloads)
                $(iframe).on("load", function () {
                    injectCSS(iframe);
                });

                // If it’s already loaded
                if (iframe.contentDocument?.readyState === "complete") {
                    injectCSS(iframe);
                }
            });
        }

        function injectCSS(iframe) {
            try {
                const doc = iframe.contentDocument;
                if (!doc) return; // cross-origin → bail

                const $head = $(doc).find("head");
                const $style = $("#jdmn-givewp-css");
                if (!$head.length || !$style.length) return;

                setTimeout(function () {
                    $(doc).find("#amount-custom").attr({
                        placeholder: "Anderer Betrag",
                        "aria-label": "Anderer Betrag",
                    });
                }, 100);

                // Prevent duplicates
                if (doc.getElementById("jdmn-givewp-css")) return;

                if ($style.is("style")) {
                    const cloned = $style.clone();
                    $head.append(cloned);
                } else if ($style.is("link")) {
                    $head.append(
                        `<link id="jdmn-givewp-css" rel="stylesheet" href="${$style.attr("href")}" type="text/css">`
                    );
                }
            } catch (e) {
                // Cross-origin → cannot access
                console.warn("Cannot inject CSS into iframe:", e);
            }
        }
    });
})();
